import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '@gen/shared';
import { InternalComponent } from './internal.component';
import { InternalRoutingModule } from './internal-routing.module';
import { HomeComponent } from './home/home.component';
import { CategoriesComponent } from './categories/categories.component';
import { BrandsComponent } from './brands/brands.component';

@NgModule({
  declarations: [InternalComponent, HomeComponent, CategoriesComponent, BrandsComponent],
  imports: [CommonModule, InternalRoutingModule, SharedModule.forRoot()],
  providers: [{ provide: LOCALE_ID, useValue: 'pt-BR' }],
})
export class InternalModule {}
